module.exports = {"500156001":"凤山街道","500156002":"芙蓉街道","500156101":"白马镇","500156102":"江口镇","500156103":"仙女山镇","500156104":"火炉镇","500156105":"鸭江镇","500156106":"羊角镇","500156107":"长坝镇","500156108":"平桥镇","500156109":"桐梓镇","500156110":"土坎镇","500156111":"和顺镇","500156112":"双河镇","500156200":"凤来乡","500156201":"庙垭乡","500156202":"石桥苗族土家族乡","500156203":"黄莺乡","500156204":"沧沟乡","500156205":"文复苗族土家族乡","500156206":"土地乡","500156207":"白云乡","500156208":"后坪苗族土家族乡","500156209":"浩口苗族仡佬族乡","500156210":"接龙乡","500156211":"赵家乡","500156212":"大洞河乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/500156.json
// module id = 2237
// module chunks = 0